import { MISSION_EXPERT_RESPONSE_STATUSES } from 'modules/pvs_activities/constants';
import React from 'react';

const defaultProps = {
    data: [],
}

const ExpertsReadOnly = (rawProps) => {
    const props = {...defaultProps, ...rawProps};    
    return (
        <table className="table table-bordered bg-white">
            <thead className='text-white' style={{ backgroundColor: 'var(--theme-dark-gray)' }}>
                <tr>
                    <th width="50px" className="text-center">#</th>
                    <th>Expert Name</th>
                    <th className="text-center">Position</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Email</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.data.length > 0 ? (
                        props.data.map((r, k) => (
                            <tr key={r.id}>
                                <td className="text-center">{k + 1}</td>
                                <td>{r.expert_name}</td>
                                <td className="text-center">{r.position_name}</td>
                                <td className="text-center">
                                    {MISSION_EXPERT_RESPONSE_STATUSES[r.response_status] ?? "-"}
                                </td>
                                <td className="text-center">
                                    {r.email}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center" colSpan={4}>
                                No Data Found
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    );
}

export default ExpertsReadOnly;
